import { usePollingBackoff } from "src/common/utils/hooks/usePollingBackoff.ts";
import { useGetJobsQuery } from "src/common/service/fusionHub/fusionHubApi.ts";
import {
	FUSION_HUB_JOB_STATUSES,
	type FusionHubJob,
} from "src/common/service/fusionHub/types.ts";
import { isJobFinished } from "src/features/integrations/jobs/isJobFinished.ts";

const ACTIVE_JOB_STATUSES = FUSION_HUB_JOB_STATUSES.filter(
	(status) => !isJobFinished(status),
);

const MAX_ACTIVE_JOBS = 200;

export const useActiveJobs = (
	companyDomainId: string,
	pollingInterval: number,
): FusionHubJob[] => {
	const [pollingIntervalMs, backOffOnError] =
		usePollingBackoff(pollingInterval);
	const { data, isError } = useGetJobsQuery(
		{
			companyDomainId,
			status: ACTIVE_JOB_STATUSES,
			take: MAX_ACTIVE_JOBS,
		},
		{ pollingInterval: pollingIntervalMs },
	);
	backOffOnError(isError);

	return data?.items ?? [];
};
